import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { IoClose } from "react-icons/io5";
import { Button } from "./ui/button";

interface ModalProps {
  show: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  width?: "sm" | "md" | "lg" | "xl" | "2xl";
  className?: string;
  closeable?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  show,
  onClose,
  children,
  width = "md",
  className = "",
  closeable = true,
}) => {
  const [_, setIsDragging] = useState(false);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  const modalRoot = document.getElementById("modal-root");
  if (!modalRoot) {
    console.error("modal-root not found in DOM");
    return null;
  }

  if (!show) return null;

  const widthClass = {
    sm: "w-64",
    md: "w-96",
    lg: "w-[28rem]",
    xl: "w-[32rem]",
    "2xl": "w-[36rem]",
  }[width];

  const handleMouseMove = () => setIsDragging(true);

  return ReactDOM.createPortal(
    <div
      key="modal"
      className="fixed inset-0 flex items-center justify-center bg-black/50 dark:bg-black/70 z-50 transition-colors duration-300"
      onMouseMove={handleMouseMove}
    >
      <div
        className={`
          bg-white dark:bg-slate-900 
          dark:border dark:border-slate-800 
          text-slate-900 dark:text-slate-100
          p-4 rounded-xl shadow-lg relative max-h-[95vh] overflow-y-auto 
          transition-colors duration-300
          ${widthClass} ${className}
        `}
        onClick={(e) => e.stopPropagation()}
      >
        {closeable && (
          <Button
            className="absolute top-0 right-0 m-2 p-2 text-gray-700 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-100"
            size={"icon"}
            variant={"ghost"}
            onClick={onClose}
          >
            <IoClose />
          </Button>
        )}

        <section className="mt-7">{children}</section>
      </div>
    </div>,
    document.getElementById("modal-root") as HTMLElement,
  );
};

export default Modal;
